import * as React from 'react'
import { View, ViewStyle, TouchableOpacity } from 'react-native'
import { useBreakpoints } from './hooks/useBreakpoints'

type ResponsiveWidth = {
	mobile?: number
	tablet?: number
	desktop?: number
}

interface TileProps {
	children: React.ReactNode
	onClick?: () => void
	style?: ViewStyle
	width?: number | ResponsiveWidth
}

export function Tile({ children, onClick, style, width = 1 }: TileProps) {
	const { isMobile, isTablet, isDesktop } = useBreakpoints()

	// Determine the active width based on responsive props
	let activeWidth: number
	if (typeof width === 'object') {
		if (isMobile && width.mobile) {
			activeWidth = width.mobile
		} else if (isTablet && width.tablet) {
			activeWidth = width.tablet
		} else if (isDesktop && width.desktop) {
			activeWidth = width.desktop
		} else {
			activeWidth = 1
		}
	} else {
		activeWidth = width
	}

	const tileStyle: ViewStyle = {
		width: '100%',
		...style,
	}

	if (onClick) {
		return (
			<TouchableOpacity style={tileStyle} onPress={onClick} activeOpacity={0.7}>
				{children}
			</TouchableOpacity>
		)
	}

	return <View style={tileStyle}>{children}</View>
}

// Example usage:
/*
<Tile
  onClick={() => console.log('Tile clicked')}
  width={{ mobile: 1, tablet: 2, desktop: 3 }}
>
  <Text>Responsive Width Tile</Text>
</Tile>
*/
